class CountdaonAnnoun extends HTMLElement {
  constructor() {
    super();

    this.currentIndex = 0;
    this.interval = null;
    this.slides = [];
    this.allSlides = [];
    this.handlePrevClick = this.previous.bind(this);
    this.handleNextClick = this.next.bind(this);
    this.handleMouseEnter = this.pause.bind(this);
    this.handleMouseLeave = this.resume.bind(this);
    this.handleVisibilityChange = this.onVisibilityChange.bind(this);
    this.handleMutations = this.onMutations.bind(this);
    this.observer = new MutationObserver(this.handleMutations);
  }

  connectedCallback() {
    this.prevButton = this.querySelector('[data-prev]');
    this.nextButton = this.querySelector('[data-next]');

    this.prevButton?.addEventListener('click', this.handlePrevClick);
    this.nextButton?.addEventListener('click', this.handleNextClick);
    this.addEventListener('mouseenter', this.handleMouseEnter);
    this.addEventListener('mouseleave', this.handleMouseLeave);
    document.addEventListener('visibilitychange', this.handleVisibilityChange);

    this.observer.observe(this, {
      subtree: true,
      attributes: true,
      attributeFilter: ['hidden'],
    });

    this.refreshSlides();
    this.resume();
  }

  disconnectedCallback() {
    this.pause();
    this.observer.disconnect();
    this.prevButton?.removeEventListener('click', this.handlePrevClick);
    this.nextButton?.removeEventListener('click', this.handleNextClick);
    this.removeEventListener('mouseenter', this.handleMouseEnter);
    this.removeEventListener('mouseleave', this.handleMouseLeave);
    document.removeEventListener('visibilitychange', this.handleVisibilityChange);
  }

  get autoplayInterval() {
    const value = Number.parseInt(this.dataset.autoplay || '', 10);

    if (!Number.isFinite(value) || value <= 0) return 0;

    return value * 1000;
  }

  onMutations(mutations) {
    const shouldRefresh = mutations.some((mutation) => {
      return mutation.target instanceof HTMLElement && mutation.target.matches('[data-announcement-slide]');
    });

    if (shouldRefresh) {
      this.refreshSlides();
    }
  }

  onVisibilityChange() {
    if (document.hidden) {
      this.pause();
      return;
    }

    this.resume();
  }

  refreshSlides() {
    this.allSlides = Array.from(this.querySelectorAll('[data-announcement-slide]'));
    this.slides = this.allSlides.filter((slide) => !slide.hidden);

    if (!this.slides.length) {
      this.pause();
      this.updateControls();
      return;
    }

    const activeSlide = this.slides.find((slide) => slide.dataset.active === 'true') || this.slides[0];
    const nextIndex = this.slides.indexOf(activeSlide);
    this.currentIndex = nextIndex >= 0 ? nextIndex : 0;

    this.update();

    if (this.slides.length < 2) {
      this.pause();
      return;
    }

    if (!document.hidden && !this.matches(':hover')) {
      this.resume();
    }
  }

  update() {
    const activeSlide = this.slides[this.currentIndex] || null;

    this.allSlides.forEach((slide) => {
      if (slide.hidden) {
        slide.dataset.active = 'false';
        slide.setAttribute('aria-hidden', 'true');
        return;
      }

      const isActive = slide === activeSlide;
      slide.dataset.active = `${isActive}`;
      slide.setAttribute('aria-hidden', `${!isActive}`);
    });

    this.updateControls();
  }

  updateControls() {
    const multipleSlides = this.slides.length > 1;

    this.prevButton?.toggleAttribute('hidden', !multipleSlides);
    this.nextButton?.toggleAttribute('hidden', !multipleSlides);
  }

  next() {
    if (this.slides.length < 2) return;

    this.currentIndex = (this.currentIndex + 1) % this.slides.length;
    this.update();
  }

  previous() {
    if (this.slides.length < 2) return;

    this.currentIndex = (this.currentIndex - 1 + this.slides.length) % this.slides.length;
    this.update();
  }

  pause() {
    if (!this.interval) return;

    window.clearInterval(this.interval);
    this.interval = null;
  }

  resume() {
    this.pause();

    if (this.slides.length < 2 || !this.autoplayInterval || document.hidden || this.matches(':hover')) {
      return;
    }

    this.interval = window.setInterval(() => {
      if (document.hidden || this.matches(':hover')) return;
      this.next();
    }, this.autoplayInterval);
  }
}

if (!customElements.get('countdaon-announ')) {
  customElements.define('countdaon-announ', CountdaonAnnoun);
}
